// ----------------------------------------------------------------------

const shape = {
  borderRadius: 6,
  borderRadiusSm: 8,
  borderRadiusMd: 10,
}

export default shape
